/**
 * @desc 创建
 */
import {
  PriceIndexEntity,
  PriceIndexForm
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreatePriceIndexParameter = PriceIndexForm

const method = 'POST'
const url = '/content/operation/priceIndex'

export const createPriceIndexApi = (
  data?: CreatePriceIndexParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PriceIndexEntity>({
    method,
    url,
    data,
    ...config
  })
}

createPriceIndexApi.method = method
createPriceIndexApi.url = url
